import React, { useEffect, useState } from 'react'
import { AXIOS } from '../api'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { ChromePicker } from 'react-color'
import { useForm } from 'react-hook-form'
import { v4 as uuidv4 } from 'uuid'
import _ from 'lodash'
import IntervalDatePicker from './common/IntervalDatePicker'
import { Pie } from 'react-chartjs-2'

import { PictureItem, Icons, Title } from './common/Themes'
import { setLoading, setFetch } from '../redux/actions'

const UpdateCodePromo = () => {

    const dispatch = useDispatch()
    const { codepromos, articles, formules } = useSelector(state => state.fetch)
    const { fetch } = useSelector(state => state.config)
    const location = useLocation()
    const [, type, pid] = location.pathname.split('/')

    const [codepromo, setCodepromo] = useState({})
    const [value, setValue] = useState([null, null])
    const [color, setColor] = useState({ hex: '#999', rgb: { r: 153, g: 153, b: 153, a: .8 } })
    const [relatedArticles, setRelatedArticles] = useState('')
    const [relatedArticlesInputValue, setRelatedArticlesInputValue] = useState('')
    const [idArticles, setIdArticles] = useState([])
    const history = useHistory()

    const [percentage, setPercentage] = useState(10)

    useEffect(() => {
        setCodepromo(codepromos.filter(codepromo => codepromo?.pid === pid)[0])
        setIdArticles(articles.map(({ id }) => id))
    }, [pid, codepromos, articles])

    useEffect(() => {
        setPercentage(codepromo?.percentage)
        setValue([codepromo?.start, codepromo?.end])
        setRelatedArticles(codepromo?.articles ? codepromo?.articles : '')
        setColor({ hex: codepromo?.color })
    }, [codepromo])

    const { handleSubmit, register, errors } = useForm()

    const onSubmit = async values => {
        try {
            dispatch(setLoading(true))
            const { label, percentage } = values
            const body = {
                label,
                percentage,
                start: value[0]._d ? new Date(value[0]._d).toISOString() : value[0],
                end: value[1]._d ? new Date(value[1]._d).toISOString() : value[1],
                articles: relatedArticles,
                status: 1,
                color: color.hex
            }

            console.log(body)

            // 👽 NEW CODE PROMO REQUEST
            await AXIOS.patch(`/api/v1/codepromos/${pid}`, body)

            history.push('/codepromos')
            dispatch(setFetch(!fetch))
            dispatch(setLoading(false))
        } catch (error) {
            console.log(error)
        }
    }

    const handleChangeRelatedArticles = e => {
        if (idArticles.includes(e.target.value * 1)) {
            if (relatedArticles.length > 0)
                setRelatedArticles(`${relatedArticles},${e.target.value}`)
            else
                setRelatedArticles(e.target.value)

        }
        setRelatedArticlesInputValue(e.target.value)
    }

    const deleteRelatedArticles = id => {
        if (relatedArticles.includes(`${id},`))
            setRelatedArticles(relatedArticles.replace(`${id},`, ''))
        else if (relatedArticles.includes(`,${id}`))
            setRelatedArticles(relatedArticles.replace(`,${id}`, ''))
        else
            setRelatedArticles(relatedArticles.replace(`${id}`, ''))
    }

    const data = {
        labels: ['Réduction', 'Prix'],
        datasets: [{
            data: [(percentage * 20) / 100, ((100 - percentage) * 20) / 100],
            backgroundColor: [
                color.hex,
                '#999'
            ],
            hoverOffset: 4,
            showTooltips: true
        }]
    }

    return (
        <div className="gestion">
            <div className="gestion__header">
                <h4 className="gestion__title">Update code promo</h4>
            </div>
            <div className="gestion__wrapper">
                <form onSubmit={handleSubmit(onSubmit)} className="form">
                    <div className="form__container">
                        <div className="form__inputboxWrapper" style={{ width: '60%' }}>
                            <Title color={'#183a68'}>Fiche code promo :</Title>
                            <div className="form__inputboxWrapper" style={{ width: '100%' }}>

                                <div className="form__inputbox" style={{ width: '48%' }}>
                                    <label htmlFor="label" className="form__label">Label</label>
                                    <input name="label" defaultValue={codepromo?.label} ref={register({ required: 'Required' })} className="form__input" />
                                    {errors.name && errors.label.message}
                                </div>

                                <div className="form__inputbox" style={{ width: '48%' }}>
                                    <label htmlFor="percentage" className="form__label">Pourcentage</label>
                                    <input name="percentage" defaultValue={codepromo?.percentage} onChange={e => setPercentage(e.target.value)} type="number" min="1" max="100" ref={register({ required: 'Required' })} className="form__input" />
                                    {errors.aid && errors.percentage.message}
                                </div>

                                <div className="form__inputbox" style={{ width: '100%' }}>
                                    <label htmlFor="birthday" className="form__label">Intervalle de dates</label>
                                    <IntervalDatePicker value={value} setValue={setValue} />
                                </div>

                                <div style={{ marginTop: '30px' }}>
                                    <div className="form__inputbox" style={{ width: '491px' }}>
                                        <label htmlFor="relatedPack" className="form__label">Activités liés</label>
                                        <input value={relatedArticlesInputValue} onFocus={() => setRelatedArticlesInputValue('')} onChange={handleChangeRelatedArticles} placeholder='Sélectionner la liste des activités' type="email" name="relatedPack" ref={register()} list="relatedPack" className="form__input" style={{ padding: '0 8px 0 14px' }} />
                                        <datalist id="relatedPack">
                                            {formules.filter(({ article }) => !relatedArticles.includes(article) && article != null).map(({ fid, article, name }) => <option className="form__dropdown" key={fid} value={article}>{name.replace("<br/>", " ")}</option>)}
                                        </datalist>
                                    </div>
                                    <div style={{ margin: '0 3rem' }}>
                                        {formules?.map(({ article, name, image }) => {
                                            return (
                                                relatedArticles?.split(',')?.map(item => {
                                                    if (article == item) return (
                                                        <div className="form__planningItem">
                                                            <PictureItem image={`${process.env.REACT_APP_SITE_MARCHAND}${image}`} style={{ width: '3rem', height: '3rem', borderRadius: '3px' }}>&nbsp;</PictureItem>
                                                            <div className="form__planningText">{name.replace('<br/>', ' ')}</div>
                                                            <Icons onClick={() => deleteRelatedArticles(article)} color="#ED292D" style={{ width: '2rem', height: '2rem', marginLeft: 'auto' }}>
                                                                <use xlinkHref="/img/sprite.svg#icon-bin2"></use>
                                                            </Icons>
                                                        </div>
                                                    )
                                                })
                                            )
                                        })}
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div className="form__container" style={{ justifyContent: 'flex-end', width: '39%', paddingRight: '20px' }}>

                            <div style={{ width: '225px', height: '225px', marginBottom: '20px' }}>
                                <Pie data={data} width={'100%'} height={'100%'} />
                            </div>

                            <div className="gestion__colorWrapper">
                                <label htmlFor="color" className="form__label">Choisir un color</label>
                                <div style={{ marginTop: '1rem' }}>
                                    <ChromePicker color={color} onChange={color => setColor(color)} />
                                </div>
                            </div>

                        </div>

                    </div>


                    <div className="gestion__buttonWrapper">
                        <button className="facture__button" style={{ fontSize: '1.5rem', width: '15rem', backgroundColor: color.hex }}>Update</button>
                        <Link to='/codepromos'>
                            <button className="facture__button" style={{ fontSize: '1.5rem', width: '15rem', backgroundColor: '#999' }}>Fermer</button>
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default UpdateCodePromo